/** CareMap home (`MapPage`): centered map column `maxWidth` in px. Keep in sync with map shell layout. */
export const CAREMAP_COLUMN_MAX_WIDTH_PX = 960;
